import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Frame 6543",
  "use": "icon-Frame 6543-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol viewBox=\"0 0 20 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Frame 6543\">\n<rect x=\"0.5\" y=\"0.5\" width=\"19\" height=\"15\" rx=\"2.5\" stroke=\"#373C42\" />\n<line x1=\"1\" y1=\"4.5\" x2=\"19\" y2=\"4.5\" stroke=\"#373C42\" />\n<line x1=\"14.5\" y1=\"11.5\" x2=\"16.5\" y2=\"11.5\" stroke=\"#373C42\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol